import { get } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  MdArrowBackIos,
  MdArrowForwardIos,
  MdCheckCircle,
  MdDescription,
  MdPeople,
} from "react-icons/md";
import Alert from "shared/components/Alert";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Header from "shared/components/Header";
import Switch from "shared/components/Input/Switch";
import { NAME_SPACES } from "shared/locales/constants";
import { CONTACT_POINT_SYSTEM } from "utils/constants";

const FORMULA_LABELS = { solo: "Formule Solo", duo: "Formule Duo", famille: "Formule Famille" };

const Comparison = ({ project, onNext, onBack }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const DETAIL = t("DETAIL", { returnObjects: true });
  const [consentMarketing, setConsentMarketing] = useState(false);
  const [consentPartners, setConsentPartners] = useState(false);
  const [nextLoading, setNextLoading] = useState(false);

  const contactEmail = get(
    (get(project, "contact.telecoms", []) || []).find(({ system }) => system === CONTACT_POINT_SYSTEM.EMAIL),
    "value",
    "",
  );
  const selectedTeleconsultation = get(project, "fields.selectedTeleconsultation", "solo");
  const totalPrice = get(project, "fields.totalPrice", 0);

  const handleSubmit = () => {
    setNextLoading(true);
    onNext({
      payload: {
        fields: {
          ...project.fields,
          consentMarketing,
          consentPartners,
          quoteGenerated: true,
          lastSelected: [],
        },
      },
      onCompleted: () => setNextLoading(false),
      onError: () => setNextLoading(false),
    });
  };

  return (
    <>
      <Header key="header" title="Génération du Devis" />
      <div className="contact-form" key="form_area">
        <div className="contact-form__content">
          <Form
            title="Génération du Devis"
            description="Génération et envoi automatique du devis personnalisé"
          >
            <Alert
              showIcon
              type="info"
              icon={<MdDescription size={16} />}
              message="Le devis sera automatiquement généré avec les produits sélectionnés et envoyé par email au prospect. Il sera valable 30 jours."
            />

            <div className="contact-stepper" key="RECAP">
              <div className="contact-stepper__header">
                <div className="contact-stepper__header--counter">
                  <span>1</span>
                </div>
                <div className="contact-stepper__header--content">
                  <h1 className="contact-stepper__header--content--title">
                    <span>Récapitulatif</span>
                  </h1>
                  <p className="contact-stepper__header--content--description">
                    Vérifiez les informations avant l'envoi
                  </p>
                </div>
              </div>
              <div className="contact-stepper__content">
                <div className="d-flex justify--between">
                  <span>Client:</span>
                  <span>{get(project, "contact.user.firstname", "")} {get(project, "contact.user.lastname", "")}</span>
                </div>
                <div className="d-flex justify--between">
                  <span>Email:</span>
                  <span>{contactEmail}</span>
                </div>
                <div className="d-flex justify--between">
                  <span>Téléconsultation:</span>
                  <span>{FORMULA_LABELS[selectedTeleconsultation] || selectedTeleconsultation}</span>
                </div>
                <div className="d-flex justify--between">
                  <strong>Total mensuel:</strong>
                  <strong className="text--primary">{totalPrice.toFixed(2)} €</strong>
                </div>
              </div>
            </div>

            <div className="contact-stepper" key="CONSENTS">
              <div className="contact-stepper__header">
                <div className="contact-stepper__header--counter">
                  <span>2</span>
                </div>
                <div className="contact-stepper__header--content">
                  <h1 className="contact-stepper__header--content--title">
                    <span>Consentements du client</span>
                  </h1>
                  <p className="contact-stepper__header--content--description">
                    Veuillez confirmer les consentements du client avant d'envoyer le devis
                  </p>
                </div>
              </div>
              <div className="contact-stepper__content">
                <div className="contact-stepper__content--radio">
                  <span className="contact-stepper__content--radio--title flex--grow-1">
                    Le client accepte d'être rappelé par La Fourgale pour la vente d'un produit de téléconsultation
                  </span>
                  <Switch
                    className="contact-stepper__content--radio--switch button__switch"
                    checkedChildren="Oui"
                    unCheckedChildren="Non"
                    checked={consentMarketing}
                    onChange={setConsentMarketing}
                  />
                </div>
                <div className="contact-stepper__content--radio">
                  <span className="contact-stepper__content--radio--title flex--grow-1">
                    Le client accepte de recevoir des informations concernant les offres de La Fourgale
                  </span>
                  <Switch
                    className="contact-stepper__content--radio--switch button__switch"
                    checkedChildren="Oui"
                    unCheckedChildren="Non"
                    checked={consentPartners}
                    onChange={setConsentPartners}
                  />
                </div>
              </div>
            </div>
          </Form>
        </div>
        <div className="contact-form__action">
          <div className="d-flex justify--between" style={{ width: "100%" }}>
            <Button onClick={onBack} type="secondary--link">
              <MdArrowBackIos size={16} />
              Précédent
            </Button>
            <Button type="primary" onClick={handleSubmit} loading={nextLoading}>
              Prévisualiser et envoyer le devis
              <MdArrowForwardIos size={16} />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Comparison;
